/**
 * AP-31 Nachtrag — **eine Website ohne `https://` ist trotzdem eine Website.**
 *
 * Das Feld war `type="url"`; der Browser lehnte damit `www.google.com` mit „Gib
 * eine URL ein" ab, bevor das Formular überhaupt abgeschickt wurde. Niemand tippt
 * das Protokoll. Das Feld ist deshalb ein Textfeld, und das Protokoll kommt beim
 * Verlassen des Feldes dazu — dieselbe Regel steht im Backend
 * (`websiteNormalisieren`), damit die Schnittstelle nicht anders speichert.
 */
export function normalisiereWebsite(eingabe: string): string {
  const roh = eingabe.trim()
  if (!roh) return ''
  return /^[a-z][a-z0-9+.-]*:\/\//i.test(roh) ? roh : `https://${roh}`
}
